// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__6dPlK","insightsList":"newBusinessInsightsMenu_insightsList__172WQ","active":"newBusinessInsightsMenu_active__2vj2w"};